'use strict';
var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');
var FormattingToolbar = React.createClass({
  render: function () {
    return (
      <div style={{
        width: '100%',
        height: '100%',
        border: '1px solid #000',
        backgroundColor:'#fff'
      }}>
        <img src={assetsHelper.getComponentAsset('formatting')} alt=""/>
      </div>
    );
  }
});

module.exports = FormattingToolbar;



// WEBPACK FOOTER //
// ./src/views/Components/FormattingToolbar.jsx